
export function Phone()
{
	return (
		<svg id="phone" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M51 32h-6c0-7.2-5.8-13-13-13v-6c10.5 0 19 8.5 19 19z"/><path d="M64 33h-6C58 18.1 45.9 6 31 6V0c18.2 0 33 14.8 33 33zM1.9 7.4C-3.5 15.5 3 32.5 17.2 46.8s31.3 20.7 39.4 15.3c.3-.1.6-.3.8-.6l5.5-5.5c1.7-1.7 1.5-4.6-.5-6.5l-9.7-9.7c-1.9-1.9-4.8-2.1-6.5-.5l-6.3 6.3c-.6.6-1.7.7-2.5.1-3.5-2.4-7-5.4-10.4-8.7-3.4-3.4-6.3-6.9-8.7-10.4-.6-.8-.5-1.9.1-2.5l6.3-6.3c1.7-1.7 1.5-4.6-.5-6.5l-9.7-9.7C12.6-.3 9.7-.5 8 1.1L2.5 6.6c-.3.2-.5.5-.6.8z"/></svg>
	);
}
